import React, { Component } from 'react';
import { Form, Input, Grid, Label, Divider, Button, Image, Header, Container } from 'semantic-ui-react'
import Select from 'react-select';
import { FootballFormParts, ShowJerseyImage } from '../football/FootballFormParts'
import { TemplateMonths } from '../templates/TemplateFormParts'
import { base, thongColors, babySizes } from '../../../config/constants.js'
import { cranesColors, boxerColors, underWearSizes, robeColors, } from '../../../config/constants.js'
import * as algoliasearch from 'algoliasearch';
import ImageUploader from '../ImageUploader'
import SiniyaDropdown from '../Siniya/SiniyaDropdown';
import KitengeSelector from '../Kitenge/KitengeSelector';
import PhoneCaseOrderParts from '../phoneCase/PhoneCaseOrderParts';
import GiftPackaging from '../Packaging/GiftPackaging';


export default class SizeAndQtyFieldsArray extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shirtSizes: [],
            shirtColors: [],
            shirtSizesSele: [],
            shirtTypes: [],
            cranesColors: [],
            options: [
                { value: 'one', label: 'One' },
                { value: 'two', label: 'Two' },
                { value: 'three', label: 'Three' }
            ],
            shirtColor: '',
            shirtSize: '',
            //NEW  STUFF
            teamSelection: '',
            //IMAGE UPLOAD
            imageUrl: 'none',
            usePuff: 'no',
            usePuffChoices: [
                { value: 'yes', label: 'Yes', category: 'usePuff' },
                { value: 'no', label: 'No', category: 'usePuff' }
            ],
            sleeves: 'short',
            sleevesChoices: [
                { value: 'short', label: 'Short Sleeved', category: 'sleeves' },
                { value: 'long', label: 'Long Sleeved', category: 'sleeves' }
            ],
            //FACE PIC
            photoType: '',
            photoTypeChoices: [
                { value: 'blackWhite', label: 'Black & White', category: 'photoType' },
                { value: 'color', label: 'Color Photo', category: 'photoType' }
            ],
            kitenge: false,
            worldCup: false,
            teamColors: '',
            selectedTeamColor: '',
            jersey_kit: false,
            wedding: false,
            jerseyQualityChoices: [
                { value: 'standard', label: 'Standard', category: 'jerseyQuality' },
                { value: 'premium', label: 'Premium', category: 'jerseyQuality' }
            ],
            faceShirt_jersey: false,
            eplPolo: false,
            phoneManufa: '',
            phoneModel: '',
            manufaOptions: [],
            phoneModelOptions: [],
            phoneImageUrl: '',
            giftPackaging: false,
            shirtTypeImageUrl:''
        }

        this.client = algoliasearch('FV5Z3H1RLH', '837deba1029595bbad3d5d1df9dabfeb');
        this.index = this.client.initIndex('phoneManufas');

        
    }



    componentDidMount() {
        console.log("hpx1 obx51 componentDidMount:" + this.props.selectDateTemplate);
        console.log("hpx12 obx52 - admin:" + this.props.admin);
        //console.log("sinx3 siniya:" + this.props.siniya);
        console.log("px1 obx53 itemSelected:" + this.props.itemSelected);
        // console.log("px12 this.props.ivanDescription:" + this.props.sentTemplate.ivanDescription);
        console.log("obx54 cardObject:" + JSON.stringify(this.props.cardObject, null, 3))

        this.checkForWorldCup();

        this.checkForJerseyKits();

        this.checkForWedding();

        this.checkForFaceShirtJersey();

        this.setShirtColors();

        //SHIRT TYPES
        this.setShirtTypes();

        //set shirt types..
        this.setShirtSizes();

        this.checkForEplPolos();

        //IF THIS IS EDIT ORDER
        if (this.props.edit) {
            console.log("etx2 its an edit order");
            this.setValuesForOrderEdit();
        }

        // base.fetch('shirtTypes', {
        //     context: this,
        //     asArray: true,
        //     state: 'shirtTypes',
        //     then(data) {
        //         // console.log(data);
        //         this.setState({
        //             shirtTypes: data
        //         })
        //     }
        // });

        //USING CARD OBJECT TYPE...
        // IT CHECK TO SEE IF THE CAROBJECT HAS SHOW SHIRT SIZE BOOLEAN
        // IF ITS FALES WE NEES NEED TO SET THE SHIRT SIZE TO THE ITEM TYPES..
        //---- SHIRT SIZE  
        if (this.props.cardObject.showShirtSizes === false) {
            console.log("obx89 this.props.cardObject.showShirtSizes === false");
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtSize', this.props.cardObject.itemType);
        }

        //---- SHIRT TYPE  
        if (this.props.cardObject.showShirtCollars === false && !this.props.cardObject.defaultShirtType) {
            console.log("obx821 this.props.cardObject.showShirtTypes === false");
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', this.props.cardObject.itemType);

        } else if (this.props.cardObject.showShirtCollars === false && this.props.cardObject.defaultShirtType) {
            console.log("obx8221 this.props.cardObject.showShirtTypes === false");
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', this.props.cardObject.defaultShirtType);
        }

        //IF SHIRT TYPE IS TRUE AND SET DEFAULT TYPES..
        if (this.props.cardObject.showShirtCollars === true && this.props.cardObject.defaultShirtType) {
            console.log("obx821 this.props.cardObject.defaultShirtType === true");
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', this.props.cardObject.defaultShirtType.key);

        }



        //---- SHIRT COLOR  
        if (this.props.cardObject.showShirtColors === false) {
            console.log("obx822 this.props.cardObject.showShirtTypes === false");
            //this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', this.props.cardObject.defaultColor);
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', this.props.cardObject.itemType);
        }

        //---- SHIRT SLEEVES  
        if (this.props.cardObject.defaultSleeves) {
            console.log("obx823 this.props.cardObject.defaultSleeves");
            this.props.updateOrderArray(this.props.arrayIndex, 'sleeves', this.props.cardObject.defaultSleeves);
        }

        /**
         * FOR FOOTBALL AND CRANES WE SET THE SHIRT TYPE
         */
        // if (this.props.itemSelected === 'football' || this.state.faceShirt_jersey) {
        if (this.state.faceShirt_jersey) {
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'football');
            this.props.updateOrderArray(this.props.arrayIndex, 'sleeves', 'short');
            this.props.updateOrderArray(this.props.arrayIndex, 'jerseyQuality', 'standard');

        }

        else if (this.props.itemSelected === 'template' || (this.props.ivanDescription && this.props.ivanDescription.includes('tribal'))) {
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'round_neck');


        }
        else if (this.props.itemSelected === 'robe') {
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'robe');

        } else if (this.props.itemSelected === 'flag') {
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'flag');
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtSize', 'flag');

        }

        else if (this.props.itemSelected === 'phoneCase') {

            this.loadManufasAlgolia();

        }

        else if (this.props.itemSelected === 'phoneCase_wooden') {
            console.log("wdx1:this.props.itemSelected === 'phoneCase_wooden'");
            this.loadManufasAlgolia_WoodenPhoneCase();

        }

        else if (this.props.itemSelected === 'bracelet') {
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'bracelet');
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', 'green');

        }


        // IF ITS A TEMPLATE WE NEED TO SAVE THE TEMPLATE TYPE
        if (this.props.cardObject.templatetype) {
            console.log("obx823 this.props.cardObject.templatetype");
            this.props.updateOrderArray(this.props.arrayIndex, 'templatetype', this.props.cardObject.templatetype);
        } else {
            console.log("obx8231 templatetype no template type..");
        }

        /**
         * IF IT CRANES AND SINIYA THEN JERSEY NUMBER IS ALWASY 60
         */
        if (this.props.itemSelected === 'cranes' && this.props.siniya) {
            this.props.updateOrderArray(this.props.arrayIndex, 'jerseyNumber', '60');
            console.log("sinx33 siniya - add name..jersey number as 60");
        }

        /**
         * add template type to size qty feilds..
         */
        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription.includes('kitenge')) {
            this.props.updateOrderArray(this.props.arrayIndex, 'kitengeShirt', this.props.sentTemplate.ivanDescription);
            this.setState({
                kitenge: true
            })
        }

        /**
         * for jersey kits we make the team jersey kits
         */

    }

    loadManufasAlgolia_WoodenPhoneCase = () => {
        console.log("wdx12 ++++++++++: loadManufasAlgolia_WoodenPhoneCase");

        this.index.searchForFacetValues({ facetName: 'manufa', facetQuery: '', filters: 'woodenAvailable:true' }).then(content => {
            console.log("wdx13:" + JSON.stringify(content.facetHits, null, 3));
            this.populateManufaSelections(content.facetHits);
        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);
        });
    }


    loadManufasAlgolia = () => {
        console.log("aglx1 ++++++++++: initAlgolia");

        this.index.searchForFacetValues({ facetName: 'manufa', facetQuery: '' }).then(content => {
            console.log("aglx13:" + JSON.stringify(content.facetHits, null, 3));
            this.populateManufaSelections(content.facetHits);
        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);
        });
    }

    loadPhoneModelsWithPics_WoodenPhoneCase = (manufa) => {
        console.log("wdx14 ++++++++++: loadPhoneModelsWithPics_WoodenPhoneCase");
        console.log("wdx15 manufas:" + manufa);

        this.index.search({
            query: manufa,
            //  facetQuery: '',
            filters: 'manufa:' + manufa + ' AND woodenAvailable:true'
        }).then(content => {
            console.log("aglx1193:" + JSON.stringify(content.hits, null, 3));
            this.populateModelSelections(content.hits);
        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);
        });

    }

    loadPhoneModelsWithPics = (manufa) => {
        console.log("aglx111 ++++++++++: loadPhoneModelsWithPics");
        console.log("aglx1192 manufas:" + manufa);

        this.index.search({
            query: manufa,
            //  facetQuery: '',
            filters: 'manufa:' + manufa
        }).then(content => {
            console.log("aglx1193:" + JSON.stringify(content.hits, null, 3));
            this.populateModelSelections(content.hits);
        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);
        });

    }

    // loadPhoneModelsAlgolia = (manufa) => {
    //     console.log("aglx19 ++++++++++: loadPhoneModelsAlgolia");
    //     console.log("aglx192 manufas:" + manufa);

    //     this.index.searchForFacetValues({
    //         facetName: 'model',
    //         facetQuery: '',
    //         filters: 'manufa:' + manufa
    //     }).then(content => {
    //         console.log("aglx193:" + JSON.stringify(content.facetHits, null, 3));
    //         this.populateModelSelections(content.facetHits);
    //     }).catch(function (err) {
    //         console.log(err);
    //         console.log(err.debugData);
    //     });

    // }

    populateManufaSelections = (algoliaManufaArray) => {
        console.log("aglx4 ++++++++++: populateManufaSelections");

        let tempFinalArray = [];

        algoliaManufaArray.map((facetHits) => {
            console.log(console.log("aglx41 inside loop:" + facetHits.value));

            let tempObj = {
                category: "phoneManufa",
                label: facetHits.value,
                value: facetHits.value,
                key: facetHits.value
            }

            tempFinalArray.push(tempObj);
            console.log("aglx43 tempFinalArray size:" + tempFinalArray.length);
        })

        console.log("aglx43 tempFinalArray FINAL size:" + tempFinalArray.length);

        this.setState({
            manufaOptions: tempFinalArray
        })
    }

    populateModelSelections = (algoliaModelArray) => {
        console.log("aglx22 ++++++++++: populateModelSelections");

        let tempFinalArray = [];

        algoliaModelArray.map((hit) => {
            console.log(console.log("aglx21 inside loop:" + hit.value));

            let tempObj = {
                category: "phoneModel",
                label: hit.model,
                value: hit.model,
                key: hit.model,
                imageUrl: hit.imageUrl,
                shirtType: hit.shirtType,
            }

            tempFinalArray.push(tempObj);
            console.log("aglx23 tempFinalArray size:" + tempFinalArray.length);
        })

        console.log("aglx23 tempFinalArray FINAL size:" + tempFinalArray.length);

        this.setState({
            phoneModelOptions: tempFinalArray
        })
    }

    /**
    * CHECK FOR WORLD CUP AND SET IT TO TRUE
    */
    checkForJerseyKits = () => {
        console.log("jk11  +++checkForJerseyKits");

        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('jersey_kit')) {
            console.log("jk1 jersey_kit is true");
            this.setState({
                jersey_kit: true,
                teamSelection: 'jersey_kit'
            })

            this.props.updateOrderArray(this.props.arrayIndex, 'teamSelection', 'jersey_kit');
            console.log("jk12 jersey_kit is updated array");

            /**
             * for jersey kits we make the team jersey kits
             */

            return true;
        } else {
            console.log("jk12 is FALSE");
            this.setState({
                jersey_kit: false
            })
            return false;
        }
    }

    /**
     * CHECK FOR WORLD CUP AND SET IT TO TRUE
     */
    checkForWorldCup = () => {
        console.log("wxc61  +++checkForWorldCup");

        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('worldCup')) {
            console.log("wxc62 worldCup is true");
            this.setState({
                worldCup: true
            })
            return true;
        } else {
            console.log("wxc64worldCup is FALSE");
            this.setState({
                worldCup: false
            })
            return false;
        }
    }

    /**
     * CHECK FOR WORLD CUP AND SET IT TO TRUE
     */
    checkForWedding = () => {
        console.log("wxc61  +++checkForWedding");

        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('wedding')) {
            console.log("wed01 checkForWedding is true");
            this.setState({
                wedding: true
            })
            return true;
        } else {
            console.log("wed02 wedding is FALSE");
            this.setState({
                wedding: false
            })
            return false;
        }
    }

    /**
   * CHECK FOR WORLD CUP AND SET IT TO TRUE
   */
    checkForFaceShirtJersey = () => {
        console.log("wxj61  +++checkForFaceShirtJersey");

        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('faceShirt_jersey')) {
            //console.log("wed01 checkForFaceShirtJersey is true");
            this.setState({
                faceShirt_jersey: true
            })
            return true;
        } else {
            //console.log("wed02 checkForFaceShirtJersey is FALSE");
            this.setState({
                faceShirt_jersey: false
            })
            return false;
        }
    }

    /**
     * CHECK FOR MANU POLOS
     */
    checkForEplPolos = () => {
        console.log("eplPol1  +++checkForEplPolos");

        if (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('_epl_polo_')) {
            console.log("eplPol11 checkForEplPolos is true");
            this.setState({
                eplPolo: true
            })

            //UPDATE THE SHIRT TYPE TO COLLAR FOR EPL POLOS
            this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', 'collar');

            //SET Tourquoise COLOR (SKY BLUE)
            if (this.props.sentTemplate.ivanDescription.includes('Tourquoise')) {
                this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', 'skyblue');
            }

            //SET YELLOW BLACK
            if (this.props.sentTemplate.ivanDescription.includes('yellow_black')) {
                this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', 'yellow');
            }

            //SET RED
            if (this.props.sentTemplate.ivanDescription.includes('red')) {
                this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', 'red');
            }

            //WHITE
            if (this.props.sentTemplate.ivanDescription.includes('white')) {
                this.props.updateOrderArray(this.props.arrayIndex, 'shirtColor', 'white');
            }




            return true;
        } else {
            console.log("eplPol12 checkForEplPolos is FALSE");
            this.setState({
                eplPolo: false
            })
            return false;
        }
    }

    /**
     * IF EDIT IS TRUE.. ITS COMEING FROM EDIT SCREEN
     * WE NEED TO SET THE VALUES IN INSTATE
     */

    setValuesForOrderEdit = () => {
        console.log("etx22 +++setValuesForOrderEdit..order");
        this.setState({
            shirtSize: this.props.shirtSize,
            shirtColor: this.props.shirtColor,
            shirtType: this.props.shirtType,
            qty: this.props.qty,
            jerseyNumber: this.props.jerseyNumber,
            jerseyName: this.props.jerseyName,
            teamSelection: this.props.teamSelection
        })

        //IF THERE IS AN IMAGE TO SEE
        if (this.props.imageUrl) {
            this.setState({
                imageUrl: this.props.imageUrl
            })
        }
    }

    setShirtTypes = () => {
        console.log("obx882 +++setShirtTypes");

        if (this.props.cardObject.showShirtCollars) {
            console.log("obx8821 this.props.cardObject.showShirtCollars");
            console.log("obx8823 this.props.cardObject.shirtCollars:" + JSON.stringify(this.props.cardObject.shirtCollars, null, 3))
            this.setState({
                shirtTypes: this.props.cardObject.shirtCollars,
            })
        }

    }

    setShirtColors = () => {

        if (this.props.cardObject.showShirtColors && this.props.cardObject.shirtColors) {
            console.log("obx881 this.props.cardObject.showShirtColors")
            this.setState({
                shirtColors: this.props.cardObject.shirtColors
            })
        }

        // if (this.props.itemSelected === 'cranes' 
        // || (this.props.sentTemplate && this.props.sentTemplate.ivanDescription 
        //     && this.props.sentTemplate.ivanDescription.includes('jersey_kit'))) {

        if ((this.props.sentTemplate && this.props.sentTemplate.ivanDescription
            && this.props.sentTemplate.ivanDescription.includes('jersey_kit'))) {
            this.setState({
                shirtColors: cranesColors
            })

        } else if (this.props.itemSelected === 'football') {
            this.setState({
                shirtColors: this.props.selectedTeamColors
            })
            // } else if (this.props.itemSelected === 'jumper' || this.props.itemSelected === 'sweat_shirt') {
        }
        // else if (this.props.itemSelected === 'sweat_shirt') {
        //     this.setState({
        //         shirtColors: jumperColors
        //     })
        // //} else if (this.props.itemSelected === 'cup' || this.props.itemSelected === 'cap') {
        // } 
        // else if (this.props.itemSelected === 'cup') {
        //     this.setState({
        //         shirtColors: cupColors,
        //     })
        // } 
        // else if (this.props.itemSelected === 'pillow') {
        //     this.setState({
        //         shirtColors: pillowColors,
        //     })
        // }

        // else if (this.props.itemSelected === 'boxer') {
        //     this.setState({
        //         shirtColors: boxerColors,
        //     })
        // } else if (this.props.itemSelected === 'thong') {
        //     this.setState({
        //         shirtColors: thongColors,
        //     })
        // }
        //  else if (this.props.itemSelected === 'baby') {
        //     this.setState({
        //         shirtColors: babyColors,
        //     })
        // }
        else if (this.props.itemSelected === 'robe') {
            this.setState({
                shirtColors: robeColors,
            })
        }
        // else if (this.props.itemSelected === 'keychain') {
        //     this.setState({
        //         shirtColor: 'white',
        //     })
        // } 
        else if (this.props.itemSelected === 'phoneCase') {
            this.setState({
                shirtColor: 'white',
            })
        } else if (this.props.itemSelected === 'jacket') {
            this.setState({
                shirtColor: 'black',
            })
        }
        // else {
        //     this.setState({
        //         shirtColors: shirtColors
        //     })
        // }
    }


    setShirtSizes = () => {

        // if (this.props.itemSelected === 'vest' || this.props.itemSelected === 'jacket') {
        //     this.setState({
        //         shirtSizes: vestSizes,
        //     })
        // } else

        if (this.props.itemSelected === 'boxer' || this.props.itemSelected === 'thong') {
            this.setState({
                shirtSizes: underWearSizes,
            })
        } else if (this.props.itemSelected === 'baby') {
            this.setState({
                shirtSizes: babySizes,
            })
        }
        // else if (this.props.itemSelected === 'keychain') {
        //     this.setState({
        //         shirtSizes: keychainShapes,
        //     })
        // } 
        else {

            if (this.props.cardObject.showShirtSizes) {
                //console.log("obx885 this.cardObject.showShirtSizes:"+JSON.stringify(this.props.cardObject.shirtSizes, null, 3))
                this.setState({
                    shirtSizes: this.props.cardObject.shirtSizes
                })
            }


        }


    }

    handleAddMoreClick = () => {
        // console.log("++++++:handleAddMoreClick");
        this.props.handleAddMoreClick(this.props.itemSelected, this.props.topDividerText);
    }

    /**
 * HANDLE DROPDOWN FOR ORDER ONE
 */
    handleOrderDetailsDropDownChanges = (value) => {
        console.log("hdx1 handleOrderDetailsDropDownChangesOrderOne");
        console.log('hdx12 wdx20  You\'ve sss:', JSON.stringify(value, null, 3));
        console.log("hdx13 jbx30 wdx22 category alone:" + value.category);
        console.log("hdx14 category:" + value.category);
        console.log('hdx15 You\'ve selected:', value.value + " " + value.category);
        console.log("hdx16 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("hdx161 - array index:" + this.props.arrayIndex);

        console.log("hdx162 - this.props.itemSelected:" + this.props.itemSelected);
        console.log("hdx163 - this.props.teamSelection:" + this.props.teamSelection);

        /**
         * IF ITS EDIT ORDER THEN WE WOULD NEED TO CHANGE THE PROPERTY IN EDIT ORDER TO MAKE IT SYNC
         * BUT FOR NEW ORDERS, WE KEEP THE STATE IN THIS COMPONENT LIKE BELOW
         */

        // if (this.props.edit) {
        //     console.log("etx3 hanlde dropdown cahnge for edit..");
        //     this.props.updateOrderArray(this.props.arrayIndex, value.category, value.value);
        // } else {
        let newState = {};
        newState[value.category] = value.value;
        console.log("hdx164 newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);

        this.props.updateOrderArray(this.props.arrayIndex, value.category, value.value);

        // SHOW IMAGE URL..
        if(value.imageUrl){
            console.log("hdx91 value.imageUrl:"+value.imageUrl);
            this.setState({
                shirtTypeImageUrl: value.imageUrl
            })
        }else{
            console.log("hdx912 NO IMAGE URL");
        }

        //LOG FOOTBALL ELECTIONS
        if (value.category === 'teamSelection') {
            console.log("hdx165 wxc23 teamSelection dropdown - " + value.value);
            console.log("hdx166 wxc24  colors of team:" + JSON.stringify(value.colors, null, 3))

            this.setState({
                teamSelection: value.value,
                teamColors: value.colors
            })

            //GET FOR WORLD CUP
            if (this.props.sentTemplate &&
                this.props.sentTemplate.ivanDescription &&
                this.props.sentTemplate.ivanDescription.includes('worldCup')) {

                console.log("hdx167 - worldCup is true getting worldcup colors");

                this.getWorldCupTeamJerseyColors(value.value);

            } else {

                console.log("hdx168 - worldCup is false getting normal team colors");
                this.getTeamJerseyColors(value.value);
            }

            this.logAmplitudeFootBallDropdownSelection(value.value);

        } else if (value.category === 'shirtColor' && ((this.props.itemSelected === 'football' && !this.state.faceShirt_jersey) ||
            (this.props.sentTemplate && this.props.sentTemplate.ivanDescription && this.props.sentTemplate.ivanDescription.includes('worldCup')))
            && !this.state.jersey_kit) {
            console.log("hdx169 wxc31 shirtColor dropdown - " + value.value);
            console.log("hdx1610 wxc32 colors of team:" + JSON.stringify(value.colors, null, 3));

            console.log("hdx1611 color:" + JSON.stringify(this.state.teamColors[value.value]), null, 3);

            //SET TEAM COLOR IN STATE
            this.setState({
                selectedTeamColor: this.state.teamColors[value.value]
            })

            //SET IMAGE URL
            this.props.updateOrderArray(this.props.arrayIndex, 'imageUrl', this.state.teamColors[value.value].imageUrl);


        } else if (value.category === 'shirtSize' && this.props.itemSelected === 'football' && this.state.teamSelection) {
            console.log("hdx1612 - shirtColor and team is set shirtColor:" + value.category + " team:" + this.state.teamSelection);
            console.log("hdx1613 shirtColor dropdown - " + value.value);
            console.log("hdx1614 colors of team:" + JSON.stringify(value.colors), null, 3)


        } else if (value.category === 'shirtType' && (value.value === 'fem_round_neck' || value.value === 'vest')) {
            console.log("hdx1615 - fem_round_neck");

            //GET THE COLORS FOR FEMALE SHIRTS..
            this.getShirtTypeColors(value.value);

            //GET THE SIZES FOR FEMALE SHIRTS
            this.getShirtTypeSizes(value.value);

        } else if (value.category === 'shirtSize' && (this.state.shirtType === 'fem_round_neck' || this.state.shirtType === 'vest')) {
            console.log("fex21 - 2nd conditons ");
            console.log("fex22 - this.state.shirtType:" + this.state.shirtType);

            //GET THE COLORS FOR FEMALE SHIRTS..
            this.getShirtTypeColors(this.state.shirtType);

            //GET THE SIZES FOR FEMALE SHIRTS
            // this.getShirtTypeSizes(value.value);

        } else if (value.category === 'shirtColor' && (this.state.shirtType === 'fem_round_neck' || this.state.shirtType === 'vest')) {
            console.log("fex21 - 2nd conditons ");
            console.log("fex22 - this.state.shirtType:" + this.state.shirtType);

            //GET THE COLORS FOR FEMALE SHIRTS..
            // this.getShirtTypeColors(this.state.shirtType);

            //GET THE SIZES FOR FEMALE SHIRTS
            // this.getShirtTypeSizes(value.value);

        } else if (value.category === 'jerseyQuality') {
            console.log("jq1 jerseyQuality:value.category === 'jerseyQuality'")

        } else if (value.category === 'phoneManufa') {
            console.log("aglx3 value.category === 'phoneManufa'");
            console.log("aglx3 value.value: " + value.value);

            this.setState({
                phoneImageUrl: ''
            })

            // this.loadPhoneModelsAlgolia(value.value);
            if (this.props.itemSelected == 'phoneCase') {
                this.loadPhoneModelsWithPics(value.value);

            } else if (this.props.itemSelected == 'phoneCase_wooden') {
                this.loadPhoneModelsWithPics_WoodenPhoneCase(value.value);
            }


        } else if (value.category === 'phoneModel') {
            console.log("aglx7 wdx17 value.category === 'phoneModel'");
            console.log("aglx71 wdx18 value.value: " + value.value);
            console.log("aglx71 wdx19 value.imageUrl: " + value.imageUrl);
            console.log("aglx71 wdx110 value.shirtType: " + value.shirtType);

            this.setState({
                phoneImageUrl: value.imageUrl
            })

            if (this.props.itemSelected === 'phoneCase_wooden') {
                console.log("wdx23 dropdown this.props.itemSelected === 'phoneCase_wooden'");
                this.props.updateOrderArray(this.props.arrayIndex, 'shirtType', value.shirtType);
            }

        } else {
            this.setShirtColors();
            this.setShirtSizes();
        }

        //  }

        //Great, the cost is 35k each for a total of 70k


    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("etx5 hx32 e.target.name:" + e.target.name);
        console.log("etx51 hx34 e.target.value:" + e.target.value);

        // if (this.props.edit) {
        //     console.log("etx3 hanlde dropdown cahnge for edit..");
        //     this.props.updateOrderArray(this.props.arrayIndex, e.target.name, e.target.value);
        // } else {
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

        this.props.updateOrderArray(this.props.arrayIndex, e.target.name, e.target.value);
        // }
    }


    /**
  * GET SHIRT TYPE COLORS
  */
    getShirtTypeSizes = (shirtType) => {
        console.log("+++++++:getShirtTypeSizes - " + shirtType);
        //SHIRT TYPES
        base.fetch('shirtSizesSele/' + shirtType, {
            context: this,
            asArray: true,
            then(data) {
                console.log("shx1 shirtColors found:" + JSON.stringify(data, null, 3))
                this.setState({
                    shirtSizes: data
                })
            }
        });
    }

    /**
   * GET SHIRT TYPE COLORS
   */
    getShirtTypeColors = (shirtType) => {
        console.log("fex31 +++++++:getShirtTypeColors - " + shirtType);
        console.log("fex32 url: shirtColors/" + shirtType);
        //SHIRT TYPES
        base.fetch('shirtColors/' + shirtType, {
            context: this,
            asArray: true,
            then(data) {
                console.log("fex32 shirtColors found:" + JSON.stringify(data, null, 3))
                this.setState({
                    shirtColors: data
                })
            }
        });
    }

    /**
    * GET THE COLORS FOR A TEAM
    */
    getTeamJerseyColors = (teamName) => {
        console.log("hdx22 +++++++:getTeamJerseyColors - " + teamName);
        //SHIRT TYPES
        base.fetch('football/teams/' + teamName + '/colors', {
            context: this,
            asArray: true,
            then(data) {
                this.setState({
                    shirtColors: data
                })
            }
        });
    }

    /**
     * GET WORLD CUP TEAM JERSEY COLORS
     */
    getWorldCupTeamJerseyColors = (teamName) => {
        console.log("wxc27 +++++++:getWorldCupTeamJerseyColors - " + teamName);
        console.log("wxc28 - :" + 'worldCup/teams/' + teamName + '/colors');
        //SHIRT TYPES
        base.fetch('worldCup/teams/' + teamName + '/colors', {
            context: this,
            asArray: true,
            then(data) {
                this.setState({
                    shirtColors: data
                })
            }
        });
    }

    logAmplitudeFootBallDropdownSelection = (value) => {

        let eventProperties = {
            teamSelected: value,
            admin: this.state.admin
        }


    }

    /**
 * WHEN FILE UPLOAD IS COMPLETE
 */
    /**
    * UPDATE STATE WHEN FILE UPLOAD IS COMPLETE
    */
    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
        // this.props.history.push('/newOrder/thankYou');
        this.props.updateOrderArray(this.props.arrayIndex, 'imageUploaded', true);
        this.props.updateOrderArray(this.props.arrayIndex, 'imageUrl', url);
    }

    getImageUploadLabel = (checkString) => {
        console.log("++++++++:getImageUploadLabel");
        console.log("checkString:" + checkString);

        var answer = 'Do you want any words on the back of your shirt?';

        if (checkString == undefined) {
            checkString = 'flag'
        }

        if (this.props.itemSelected === 'flag') {
            checkString = 'flag'

        } else if (this.props.itemSelected === 'keychain') {
            checkString = 'keychain'

        } else if (this.props.itemSelected === 'phoneCase') {
            checkString = 'phoneCase'
        }

        //this.props.faceShirt === true || this.props.ivanDescription === 'blankShirt'
        // ? <label>{'Please upload a pic for your shirt image'}</label>
        // : <label>{'Do you want any words on the back of your shirt?'}</label>

        if (checkString.includes('faceShirt')) {
            answer = 'Please upload a pic for your shirt image';

        } else if (checkString.includes('bizpackage')) {
            answer = 'Please upload your company logo if available';

        } else if (checkString.includes('flag')) {
            answer = "Please upload the image you would like on your flag"

        } else if (checkString.includes('keychain')) {
            answer = "If you want an image on your keychain pls upload it here"

        } else if (checkString.includes('phoneCase')) {
            answer = "If you want an image on your phone Case pls upload it here"

        } else {
            answer = "Please upload the image you would like on your item"
        }

        return answer;
    }

    addGiftPackagingFunction = () => {
        console.log("++++++ addGiftPackagingFunction");

        this.setState({
            giftPackaging: true
        })

    }

    render() {

        console.log("SAA ivanDescription:" + this.props.ivanDescription);

        const templateSelectMonthField = this.props.monthTemplate ? (
            <TemplateMonths
                monthSelected={this.props.monthSelected}
                handleOrderDetailsDropDownChanges={this.props.handleOrderDetailsDropDownChanges} />
        ) : ''

        /**
         * DEPENDING OF ITS A MONTH SELECTED OR NOT THE SPECIEL FIELD WILL BE MONTH DROP DOWN OR NOT..
         */
        // const templateGenericField = this.props.selectDateTemplate
        //     && !this.props.siniya
        //     && this.props.sentTemplate.ivanDescription != 'couples_jersey'
        //     && !this.props.sentTemplate.ivanDescription.includes('eplJumpers')
        //     && !this.props.sentTemplate.ivanDescription.includes('shop_')
        //     && !this.props.sentTemplate.ivanDescription.includes('avengers_')
        //     && !this.props.sentTemplate.ivanDescription.includes('kitenge')
        //     && !this.props.sentTemplate.ivanDescription.includes('worldCup')
        //     && !this.state.eplPolo
        //     //&& !this.props.sentTemplate.ivanDescription.includes('eplStore_manu_polo_')
        //     ? <div>
        //         <Label pointing='below' color='blue'>{this.props.templateSpecialFieldLabel}</Label>
        //         <Form.Field
        //             name={'templateText'}
        //             value={this.props.templateGenericField}
        //             control={Input}
        //             placeholder={this.props.templateSpecialFieldLabel}
        //             onChange={this.handleTextInputChange}
        //             error={this.props.formErrorFieldArray[this.props.templateGenericField]} />
        //     </div>
        //     : ''

        const shirtSizeLabel = this.props.itemSelected !== 'keychain'
            ? <Label pointing='below' color='blue'>{'SIZE'}</Label>
            : <Label pointing='below' color='blue'>{'SHAPE'}</Label>

        /**
         * SHIRT SIZE
         */
        // const shirtSize = this.props.itemSelected !== 'cup'
        //     && this.props.itemSelected !== 'pillow'
        //     && this.props.itemSelected !== 'cap'
        //     && this.props.itemSelected !== 'robe'
        //     && this.props.itemSelected !== 'flag'
        //     && this.props.itemSelected !== 'phoneCase'
        //     && this.props.itemSelected !== 'clock'
        //     && this.props.itemSelected !== 'bracelet'
        //     && this.props.itemSelected !== 'storageBoxes'
        const shirtSize = this.props.cardObject.showShirtSizes


            // && this.props.itemSelected !== 'keychain'
            ? <Grid.Column>
                {/* SHIRT SIZE */}
                {/* <Label pointing='below' color='blue'>{'SIZE'}</Label> */}
                {shirtSizeLabel}
                <Select
                    name="form-field-name"
                    value={this.state.shirtSize}
                    //value={'medium'}
                    //options={this.state.shirtSizesSele}
                    options={this.state.shirtSizes}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                    required={true}
                />
            </Grid.Column>
            : ''

        /**
         * CUP COLOR
         */

        // const itemColor = this.props.itemSelected !== 'keychain'
        //     && !this.state.eplPolo
        //     && this.props.itemSelected !== 'phoneCase'
        //     && this.props.itemSelected !== 'jacket'
        //     && this.props.itemSelected !== 'clock'
        //     && this.props.itemSelected !== 'bracelet'
        //     && this.props.itemSelected !== 'storageBoxes'

        const itemColor = this.props.cardObject.showShirtColors
            ? <Grid.Column>
                {/* SHIRT COLOR */}
                <Label pointing='below' color='blue'>{'COLOR'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.shirtColor}
                    options={this.state.shirtColors}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                    required={true}
                />
            </Grid.Column>
            : ''

        const firstRow = (
            <Grid columns='equal'>

                {/* SHIRT SIZE */}
                {shirtSize}

                {itemColor}
            </Grid>
        )

        /**
         * THE SHIRT TYPE DOES NOT APPEAR FOR CRANES SHIRTS..
         */
        //const shirtTypeColumn = (this.props.itemSelected === 't-shirts' && this.state.eplPolo == false)
        const shirtTypeColumn = (this.props.cardObject.showShirtCollars)

            ? <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{'ITEM TYPE'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.shirtType}
                    options={this.state.shirtTypes}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <br />

        // const shirtTypeColumn = this.props.itemSelected === 't-shirts' 
        // ||(this.props.sentTemplate && !this.props.sentTemplate.ivanDescription.includes('tribal')
        //         && !this.state.worldCup
        //         && !this.state.jersey_kit
        //         && !this.props.sentTemplate.ivanDescription.includes('eplJumpers')
        //         && !this.props.sentTemplate.ivanDescription.includes('illow')
        //         && !this.props.sentTemplate.ivanDescription.includes('cup')
        //         && !this.props.sentTemplate.ivanDescription.includes('umper')
        //         && !this.props.sentTemplate.ivanDescription.includes('faceShirt_jersey')
        //         && !this.props.sentTemplate.ivanDescription.includes('_robe'))
        //         // && !this.props.sentTemplate.ivanDescription.includes('eplStore_arsenal_polo_')
        //         // && !this.props.sentTemplate.ivanDescription.includes('eplStore_manu_polo_'))
        //     ? <Grid.Column >
        //         {/* SHIRT TYPE */}
        //         <Label pointing='below' color='blue'>{'SHIRT COLLAR'}</Label>
        //         <Select
        //             name="form-field-name"
        //             value={this.state.shirtType}
        //             options={this.state.shirtTypes}
        //             onChange={this.handleOrderDetailsDropDownChanges}
        //             searchable={false}
        //             clearable={false}
        //         />
        //     </Grid.Column>
        //     : <br />


        /**
         * SHOW THE CHILDS AGE WHEN BABY IS SELECTED
         */
        const childsAge = this.state.shirtSize === 'baby' ? (
            <Grid.Column >
                {/* BABYS AGE */}
                <Label pointing='below' color='blue'>CHILD'S AGE</Label>
                <Form.Field
                    name={'childsAge'}
                    value={this.state.childsAge}
                    control={Input}
                    type='number' max={50}
                    placeholder={'Child Age'}
                    onChange={this.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.childsAgeTextFeildName]} />
            </Grid.Column>
        )
            : ''

        const secondRow = (
            <Grid columns='equal'>

                {shirtTypeColumn}


                {/* INPUT FOR CHILDS AGE */}
                {childsAge}

                <Grid.Column >
                    {/* QUANTITY */}
                    <Label pointing='below' color='blue'>QUANTITY</Label>
                    <Form.Field
                        name={'qty'}
                        value={this.state.qty}
                        control={Input}
                        type='number' max={500} required
                        placeholder={'Quantity'}
                        onChange={this.handleTextInputChange}
                        error={this.props.formErrorFieldArray[this.props.qtyTextFeildName]}
                    />
                </Grid.Column>
            </Grid>
        )


        const whatsappContact =
            <a href="http://bit.ly/2t2Ckjr">Click here to whatsapp us if you have issue with placing your order</a>


        const topDivider = (
            <div>
                <br />
                <Divider horizontal>{this.props.topDividerText}</Divider>
                {whatsappContact}
                <br />
            </div>

        )

        /**
         * JERSEY NUMBER
         */
        //const jerseyNumber = ((this.props.itemSelected === 'cranes' || this.props.itemSelected === 'football') && !this.props.siniya && !this.state.faceShirt_jersey ?
        const jerseyNumber = (this.props.cardObject.showJerseyNumber ?
            <div>
                <Label pointing='below' color='blue'>What number on the back of your Jersey?</Label>

                <Form.Field
                    name={'jerseyNumber'}
                    value={this.state.jerseyNumber}
                    control={Input}
                    length='2'
                    type='number' required
                    placeholder={'Jersey Number'}
                    onChange={this.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.jerseyNumberFieldName]} />
                {/* <label>{'** NOTICE - There is a extra charge of 5,000 for numbers'}</label> */}
            </div>
            : ""
        )

        /**
        * JERSEY NAME  showJerseyName
        */
        //const jerseyName = ((this.props.itemSelected === 'cranes' || this.props.itemSelected === 'football') && !this.props.siniya && !this.state.faceShirt_jersey ?
        const jerseyName = (this.props.cardObject.showJerseyName ?
            <div>
                <br />
                <Label pointing='below' color='blue'>What name on the back of your Jersey?</Label>
                <Form.Field
                    name={'jerseyName'}
                    value={this.state.jerseyName}
                    control={Input}
                    length='2'
                    placeholder={'Jersey Name'}
                    onChange={this.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.jerseyNameFieldName]} />
            </div>
            : ""
        )


        /**
      * SHOW PARTS FOR FOOTBALL FORM..
      */
        const footBallTeam = this.props.itemSelected === 'football' && !this.state.jersey_kit
            ? <FootballFormParts
                teamSelection={this.state.teamSelection}
                handleFootballDropDownChange={this.handleOrderDetailsDropDownChanges}
                handleTextInputChange={this.handleTextInputChange}
                typedInTeamName={this.props.typedInTeamName}
                typedInTeamNameFieldName={this.props.typedInTeamNameFieldName}
                ivanDescription={this.props.ivanDescription}
                admin = {this.props.admin} />
            : ''


        const mainUi = (
            <div>

                {topDivider}

                {/* FIRST ROW */}
                {firstRow}

                {/* SECOND ROW */}
                {secondRow}

                <br />
                If you need different sizes and colors e.g (2) Blue Large (1) Small Green
                <Button color='green' content='Add More Quantities And Colors' icon='plus cart' labelPosition='left' />
            </div>
        )



        const moreButton = !this.props.template || this.state.worldCup || this.state.jersey_kit || this.state.wedding
            ?
            <div>
                <br />
                <Button type='Button' onClick={this.handleAddMoreClick}
                    color='green' content='Add More Quantities And Colors'
                    icon='plus' labelPosition='left' />
            </div>
            : ''
        /**
        * WORDS ON SHIRTS - NOT SHOW ON CRANES OR EPL JERSEYS..
        */
        // const wordsOnShirt = this.props.itemSelected !== 'cranes'
        //     && this.props.itemSelected !== 'football'
        //     && this.props.itemSelected !== 'template'
        //     && this.props.template !== true
        //     && this.props.faceShirt !== true
        //     && this.props.itemSelected !== 'jacket'
        //     && this.props.itemSelected !== 'storageBoxes'
        //     ? <Form.Field>
        //         <label>{this.props.wordsOnItemLabel}</label>
        //         <Form.Input
        //             fluid
        //             name={'shirtText'}
        //             value={this.state.shirtText}
        //             icon='sort alphabet ascending'
        //             iconPosition='left'
        //             placeholder='Text on your item'
        //             onFocus={this.props.amp_logFieldClick}
        //             onChange={this.handleTextInputChange}
        //         />
        //     </Form.Field>
        //     : ''

        const wordsOnShirt = this.props.cardObject.wordsOnFront
            // && this.props.itemSelected !== 'football'
            // && this.props.itemSelected !== 'template'
            // && this.props.template !== true
            // && this.props.faceShirt !== true
            // && this.props.itemSelected !== 'jacket'
            // && this.props.itemSelected !== 'storageBoxes'
            ? <Form.Field>
                <label>{this.props.cardObject.wordsOnItemLabel}</label>
                <Form.Input
                    fluid
                    name={'shirtText'}
                    value={this.state.shirtText}
                    icon='sort alphabet ascending'
                    iconPosition='left'
                    placeholder='Text on your item'
                    onFocus={this.props.amp_logFieldClick}
                    onChange={this.handleTextInputChange}
                />
            </Form.Field>
            : ''


        const wordsOnBackOfshirtLabel = this.props.itemSelected === 'keychain'
            ? <label>{'What would you like on THE BACK of your keychain'}</label>
            : <label>{'Do you want any words on the back of your shirt?'}</label>

        /**
   * WORDS ON SHIRTS - NOT SHOW ON CRANES OR EPL JERSEYS..
   */
        const wordsOnBackOfshirt = this.props.cardObject.wordsOnBack

            ? <Form.Field>
                {/* <label>{'Do you want any words on the back of your shirt?'}</label> */}
                {wordsOnBackOfshirtLabel}
                <Form.Input
                    fluid
                    name={'shirtBackText'}
                    value={this.state.shirtBackText}
                    icon='sort alphabet ascending'
                    iconPosition='left'
                    placeholder='Text on Back'
                    onFocus={this.props.amp_logFieldClick}
                    onChange={this.handleTextInputChange}
                />
            </Form.Field>
            : ''


        // const imageUploadLabel = this.props.faceShirt === true || this.props.ivanDescription === 'blankShirt'
        //     ? <label>{'Please upload a pic for your shirt image'}</label>
        //     : <label>{'Do you want any words on the back of your shirt?'}</label>

        // const imageUploadLabel = this.props.ivanDescription
        //     || this.props.itemSelected === 'flag'
        //     || this.props.itemSelected === 'keychain'
        //     || this.props.itemSelected === 'phoneCase'
        //     ? <label>{this.getImageUploadLabel(this.props.ivanDescription)}</label>
        //     : <label>{'Do you want any words on the back of your shirt?'}</label>

        const imageUploadLabel = this.props.cardObject.imageUpload && this.props.cardObject.imageUploadButtonLabel

            ? <label>{this.props.cardObject.imageUploadButtonLabel}</label>
            : <label>{'Do you want an image on your item?'}</label>



        /**
        * SHOW IMAGE UPLOAD
        */
        // const imageUpload = (this.props.itemSelected === 't-shirts' && this.props.template !== true)
        //     || (this.props.itemSelected === 'flag' && this.props.template !== true)
        //     || (this.props.itemSelected === 'jumper' && this.props.template !== true)
        //     || (this.props.itemSelected === 'sweat_shirt' && this.props.template !== true)
        //     || (this.props.itemSelected === 'cup' && this.props.template !== true)
        //     || (this.props.itemSelected === 'cap' && this.props.template !== true)
        //     || (this.props.itemSelected === 'vest' && this.props.template !== true)
        //     || (this.props.itemSelected === 'pillow' && this.props.template !== true)
        //     || (this.props.itemSelected === 'phoneCase' && this.props.template !== true)
        //     || ((this.props.faceShirt === true
        //         || this.props.ivanDescription === 'blankShirt'
        //         || (this.props.ivanDescription && this.props.ivanDescription.includes('bizpack'))) && this.props.template === true)
        //     || (this.props.itemSelected === 'keychain' && this.props.template !== true)
        //     || (this.props.itemSelected === 'jacket' && this.props.template !== true)
        //     // INCLUDED IMAGE UPLOAD ON ALL BLANK CREATE YOUR OWN SHIRTS
        //     || (this.props.template === true && this.props.ivanDescription && (this.props.ivanDescription.includes('blank')
        //         || this.props.ivanDescription.includes('enter_birthday_photo_jmpr')
        //         || this.props.ivanDescription.includes('enter_birthday_cup')))
        //     ? <div>

        //         <Header as='h5'>{imageUploadLabel}</Header>
        //         <ImageUploader
        //             updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
        //             storageReference={'orderDesigns'} />
        //         {imagePreview}
        //     </div>
        //     : (<p></p>)

        const imageUpload = this.props.cardObject.imageUpload
            ? <div>

                <Header as='h5'>{imageUploadLabel}</Header>
                <ImageUploader
                    updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                    storageReference={'orderDesigns'} />
                {imagePreview}
            </div>
            : (<p></p>)


        /**
         * SHOWS IMAGE PREVIEW OF WHAT'S BEEN UPLOADED
         */
        const imagePreview = this.state.imageUrl != 'none'
            && (this.props.itemSelected === 't-shirts'
                || this.props.itemSelected === 'jumper'
                || this.props.itemSelected === 'sweat_shirt'
                || this.props.itemSelected === 'cup'
                || this.props.itemSelected === 'pillow'
                || this.props.itemSelected === 'flag'
                || this.props.itemSelected === 'phoneCase'
                || this.props.faceShirt === true)
            ? (<Image src={this.state.imageUrl} size='small' centered bordered shape='rounded' />)
            : (<p></p>)

        /**
         * USE PUFF OR NOT PUFF
         */
        const usePuffDropDown = this.props.itemSelected !== 'football'
            && this.props.itemSelected !== 'cranes'
            && this.props.itemSelected !== 'keychain'
            && this.props.itemSelected !== 'phoneCase'
            && this.props.itemSelected !== 'clock'
            && this.props.itemSelected !== 'bracelet'
            && this.props.admin
            ? <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{'USE PUFF PRINT'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.usePuff}
                    options={this.state.usePuffChoices}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <br />

        /**
         * USE PUFF OR NOT PUFF
         */
        //const sleevesDropdown = (this.props.itemSelected === 'football' || this.props.itemSelected === 'cranes') && !this.state.worldCup && !this.state.jersey_kit
        const sleevesDropdown = this.props.cardObject.showSleevesDropdown
            ? <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{'SLEEVES?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.sleeves}
                    options={this.state.sleevesChoices}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <br />

        /**
         * BLACK OR WHITE COLOR PHOTO
         */
        const photoTypeDropDown = this.props.faceShirt === true && !this.state.faceShirt_jersey
            ? <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{'What type of Photo, color or black & white?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.photoType}
                    options={this.state.photoTypeChoices}
                    onChange={this.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <br />

        // const siniyaDonationFeild = (this.props.siniya ?
        //     <Grid columns='equal'>

        //         <Grid.Column >
        //             {/* SINIYA DONATION */}
        //             <Label pointing='below' color='blue'>ADD DONATION FOR SINIYA</Label>
        //             <Form.Field
        //                 name={'siniyaDonation'}
        //                 value={this.state.siniyaDonation}
        //                 control={Input}
        //                 type='number'
        //                 placeholder={'ADD DONATION FOR SINIYA'}
        //                 onChange={this.handleTextInputChange}
        //                 error={this.props.formErrorFieldArray[this.props.qtyTextFeildName]} />
        //         </Grid.Column>
        //     </Grid>
        //     : ''
        // )

        /**
         * Dropdown to select what siniya house they are in.
         */
        const siniyaHouseDropdown = this.props.siniya && this.props.itemSelected === 'cranes'
            ? <SiniyaDropdown
                jerseyName={this.state.jerseyName}
                handleOrderDetailsDropDownChanges={this.handleOrderDetailsDropDownChanges} />
            : ''

        const ivanDescription = this.props.sentTemplate && this.props.sentTemplate.ivanDescription
            ? this.props.sentTemplate.ivanDescription
            : ''

        const kitengeSelectionDropDown = (this.props.sentTemplate && this.props.sentTemplate.ivanDescription.includes('kitenge'))
            || (this.props.itemSelected === 't-shirts')
            ? <KitengeSelector
                updateOrderArray={this.props.updateOrderArray}
                arrayIndex={this.props.arrayIndex}
                itemType={this.props.itemSelected}
                kitenge={this.state.kitenge}
                ivanDescription={ivanDescription}
            />
            : ''

        const giftPackaging = <GiftPackaging
            itemType={this.props.itemSelected}
            updateOrderArray={this.props.updateOrderArray}
            arrayIndex={this.props.arrayIndex} />;


        const qualityPrompt = this.props.itemSelected === 'football'
            ? <div>
                <Header as='h5' color='blue' textAlign='center'>
                    {' '}** Jersey Type **
        <br />
                    {' '}Order the STANDARD Jersey -  40,000 UGX
            <br />
                    {' '}** OR **
        <br />
                    {' '}Order the PREMIUM QUALITY -  85,000 UGX
    </Header>
            </div>
            : ''


        /**
         * FOOTBALL PREMIUM OR STANDARD
         */
        const jerseyQualityDropdown = (this.props.itemSelected === 'football') && !this.state.worldCup && !this.state.jersey_kit
            ? <div>
                {/* {qualityPrompt} */}
                <Grid.Column >
                    {/* jersey quality*/}
                    <Label pointing='below' color='blue'>{'Jersey Type?'}</Label>
                    <Select
                        name="form-field-name"
                        value={this.state.jerseyQuality}
                        options={this.state.jerseyQualityChoices}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />
                </Grid.Column>
            </div>
            : <br />

        const phoneCaseManualEntryFeilds = this.props.itemSelected === 'phoneCase'
            ? <div>
                {/* phone manufa */}
                <h4> IF YOU COULD NOT FIND YOUR PHONE MAKE, PLEASE TYPE IT IN BELOW </h4>
                <Label pointing='below' color='blue'>PHONE MANUFACTURER</Label>
                <Form.Field
                    name={'phoneManufa'}
                    value={this.state.phoneManufa}
                    control={Input}
                    placeholder={'Enter your Phone Manufacturer (e.g. Samsung)'}
                    onChange={this.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.qtyTextFeildName]}
                />

                {/* phone model */}
                <h4> IF YOU COULD NOT FIND YOUR PHONE MODEL, PLEASE TYPE IT IN BELOW </h4>
                <Label pointing='below' color='blue'>PHONE MODEL</Label>
                <Form.Field
                    name={'phoneModel'}
                    value={this.state.phoneModel}
                    control={Input}
                    placeholder={'Enter your Phone Manufacturer (e.g. C8)'}
                    onChange={this.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.qtyTextFeildName]}
                />
            </div>
            : ''

        const phoneCaseDetails = this.props.itemSelected === 'phoneCase' || this.props.itemSelected === 'phoneCase_wooden'
            ? <div>

                {/* phone make dropdown */}
                <PhoneCaseOrderParts
                    phoneManufa={this.state.phoneManufa}
                    phoneModel={this.state.phoneModel}
                    manufaOptions={this.state.manufaOptions}
                    phoneModelOptions={this.state.phoneModelOptions}
                    phoneImageUrl={this.state.phoneImageUrl}
                    handleOrderDetailsDropDownChanges={this.handleOrderDetailsDropDownChanges}
                    handleTextInputChange={this.handleTextInputChange}
                    typedInTeamName={this.props.typedInTeamName}
                    typedInTeamNameFieldName={this.props.typedInTeamNameFieldName}
                    ivanDescription={this.props.ivanDescription} />

                {phoneCaseManualEntryFeilds}

            </div>
            : ''

        const showSpecialDisplayText = this.props.cardObject.specialDisplayText
            ? <h4>{this.props.cardObject.specialDisplayText}</h4>
            : ''

        const shirtDressImage = this.props.itemSelected === 'shirtDress'
            ? <Image height='500' width='500' centered src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2FshirtDresses%2FShirtDressComparison.jpg?alt=media&token=03917146-2fee-4357-b11b-934e379af454' size='small' />
            : ''

        const showShirtTypeImage = this.state.shirtTypeImageUrl != '' 
            // const showJersey = props.teamSelection && props.itemSelected === 'football' 
            ? <Container>
                <br />
                {/* Disabled Image On Jersey Selection / jersey image */}
                <Image src={this.state.shirtTypeImageUrl} size='small' centered />
            </Container>
            : ""

        const showIfVisible = this.props.visible
            ? (<div>
                {topDivider}

                {showSpecialDisplayText}

                <br />
                {wordsOnShirt}

                {wordsOnBackOfshirt}

                {/* IMAGE UPLOAD */}
                {imageUpload}

                {/* IMAGE PREVIEW */}
                {imagePreview}

                {shirtDressImage}

                {/* {usePuffDropDown} */}

                {/* WHEN MONTH IS SELECTED */}
                {templateSelectMonthField}

                {siniyaHouseDropdown}

                {/* GENERIC TEXT FIELD TO TEMPLATE */}
                {/* {templateGenericField} */}

                {/* FOOTBALL team */}
                {footBallTeam}

                {/* JERSEY NAME */}
                {jerseyName}

                {/* JERSEY NUMBER */}
                {jerseyNumber}

                {/* FIRST ROW */}
                {/* {firstRow} */}
                {secondRow}

                <ShowJerseyImage
                    teamSelection={this.state.teamSelection}
                    itemSelected={this.props.itemSelected}
                    shirtColor={this.state.shirtColor}
                    selectedTeamColor={this.state.selectedTeamColor}
                    worldCup={this.state.worldCup} />

                {/* SHOW SHIRT TYPE IMAGE */}
                {showShirtTypeImage}

                {/* SLEEVES */}
                {sleevesDropdown}

                {/* SECOND ROW */}
                {/* {secondRow} */}
                {firstRow}

                {/* COLOR OF PHOTO */}
                {photoTypeDropDown}

                {/* SINIYA DONATION FEILD */}
                {/* {siniyaDonationFeild} */}

                {/* GIFT Packaging */}
                {/* {giftPackaging} */}

                {/* Kitenge SELECTION  */}
                {kitengeSelectionDropDown}



                {/* JERSEY QUALITY DROPDOWN */}
                {/* {jerseyQualityDropdown} */}
                {phoneCaseDetails}

                {/* MORE BUTTON */}
                {moreButton}

            </div>)
            : (<p></p>)

        return (
            <div>
                {showIfVisible}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/SingleOrderFromArray/SizeAndQtyFieldsArray.js